import { Component, Input, Output, EventEmitter, ViewChild, OnInit } from '@angular/core';
import { Mediaclip } from '../../../interfaces/mediaclip';
import { BbFrameSelectComponent, ScreenshotImage } from '../bb-frame-select/bb-frame-select.component';
import { ConfigCropset, Thumbnail } from '../thumbnail-selector/thumbnail-selector.component';

@Component({
	selector: 'bb-screenshot',
	templateUrl: './bb-screenshot.component.html',
	styleUrls: ['./bb-screenshot.component.scss']
})

export class BbScreenshotComponent implements OnInit {
	// mediaclip OR image
	@Input() mediaclip: Mediaclip;
	@Input() image: ScreenshotImage;

	@Output() onSave: EventEmitter<Partial<Thumbnail>> = new EventEmitter();
	@Output() onCancel: EventEmitter<void> = new EventEmitter();

	@ViewChild(BbFrameSelectComponent) bbFrameSelect: BbFrameSelectComponent;

	isNew = true;

	constructor() {}

	ngOnInit(): void {
		if (this.image?.src || this.image?.data) {
			this.isNew = false;
		}
	}

	onCropsetChange(cropset: ConfigCropset) {
		if (!this.image?.crop || !cropset) {
			return;
		}

		this.isNew = cropset.name !== this.image.cropsetName;
	}

	onCancelClick() {
		this.onCancel.emit();
	}

	onSaveClick() {
		const screenshot = this.bbFrameSelect.getScreenshotCurrentTime();

		this.onSave.emit(screenshot);
	}
}
